function SocialIcon() {
  return (
    <div className="socialIcon">
      <a href="https://wa.me/639380386385" target="__blank">
        <i className="fa-brands fa-whatsapp"></i>
      </a>
      <a href="https://messenger.com/t/100008461001743/" target="__blank">
        <i className="fa-brands fa-facebook-messenger"></i>
      </a>
      <a href="https://github.com/InanCelis" target="__blank">
        <i className="fa-brands fa-github"></i>
      </a>
      <a
        href="https://linkedin.com/in/ferdinand-celis-099394172/"
        target="__blank"
      >
        <i className="fa-brands fa-linkedin-in"></i>
      </a>
    </div>
  );
}

export default SocialIcon;
